<template>
  <div class="money-tag" :style="color ? `color: ${color}` : ''">
    <i class="tag__icon">¥</i>
    <span class="tag__text">{{amount}}</span>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: [Number, String],
      default: 0
    },
    color: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="stylus" scoped>
.money-tag {
  display: flex;
  align-items flex-end
  color #FF9645
}

.tag__icon {
  font-size 10px
  font-style normal
}

.tag__text {
  margin-left 2px
  font-size 16px
  font-weight 500
}
</style>
